<script lang="ts" setup>
import { computed, ref } from 'vue'

import SupportDialog from '~/components/Header/HeaderNavigationDrawer/SupportDialog.vue'
import ChatIcon from '~/components/Icons/ChatIcon.vue'
import UserAccountIcon from '@/components/Icons/UserAccount.vue'

import { useCityStore } from '~/store/city/city'
import { useUserStore } from '~/store/user/user'

const cityStore = useCityStore()
const userStore = useUserStore()
const { isTablet } = useDevice()

const props = defineProps({
  navShow: {
    type: Boolean,
    required: true,
  },
})
const emit = defineEmits(['openNavigationDrawer'])

const isDialogCallSupportShow = ref(false)
const isCitySelectListShow = ref(false)
const isAuthenticated = computed(() => userStore.isAuthenticated)

const isActive = computed(() => cityStore.cityInfo.is_active)
const padeg = computed(() => cityStore.cityInfo.padeg)

const openNavigationDrawer = () => {
  emit('openNavigationDrawer')
}
</script>

<template>
  <header class="header-mobile">
    <nuxt-link class="header-mobile__logo" to="/">
      <nuxt-img
        src="/logo-mobile.svg"
        alt="Логотип компании Фарфор"
        width="30"
        height="30"
      />
    </nuxt-link>

    <div class="header-mobile__city">
      <header-city-select
        :is-city-select-list-show="isCitySelectListShow"
        :city-name="padeg?.imen"
        class="information__city-select"
      />
      <header-working-hours
        class="information__city-hours"
        @show-city-select-list="isCitySelectListShow = !isCitySelectListShow"
      />
    </div>

    <div class="header-mobile__actions">
      <app-button
        v-if="isActive"
        :ripple="true"
        variant="text"
        icon
        width="36px"
        height="40px"
        @click="isDialogCallSupportShow = !isDialogCallSupportShow"
      >
        <chat-icon />
      </app-button>

      <app-button
        v-if="isTablet"
        :ripple="true"
        variant="text"
        icon
        width="36px"
        height="40px"
        size="20"
        :to="isAuthenticated ? '/profile/orders/' : '/login/'"
      >
        <user-account-icon />
      </app-button>

      <app-button :ripple="true" variant="text" icon width="36px" height="40px">
        <svg
          width="30"
          height="30"
          viewBox="0 0 100 100"
          :class="{ opened: props.navShow }"
          :aria-expanded="!props.navShow"
          @click="openNavigationDrawer"
        >
          <path
            class="line line1"
            d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
          />
          <path class="line line2" d="M 20,50 H 80" />
          <path
            class="line line3"
            d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
          />
        </svg>
      </app-button>
    </div>

    <app-dialog v-model="isDialogCallSupportShow">
      <template #title>
        <h2 class="dialog__title">Связаться с поддержкой</h2>
      </template>
      <template #body>
        <support-dialog />
      </template>
    </app-dialog>
  </header>
</template>

<style scoped lang="scss">
.header-mobile {
  position: sticky;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1005;
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  gap: 0 20px;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  background: $white;
  border-bottom: 1px solid #f1f4f9;

  &__logo {
    width: 28px;
    height: 28px;
  }

  &__city {
    @include media('>=tablet', '<=desktop-mini') {
      display: grid;
      grid-template-columns: max-content max-content;
      gap: 0 35px;
      align-items: center;
    }
  }

  &__actions {
    display: flex;
    gap: 0 5px;

    :deep(.v-btn__overlay) {
      display: none;
    }

    :deep(.v-btn) {
      color: #9e9e9e !important;
    }
  }
}

.dialog__title {
  position: absolute;
  padding-left: 35px;
  font-size: 16px;
  font-weight: 800;
  color: $text-black;
  text-align: center;
  @include media('>=tablet', '<=desktop-mini') {
    padding-left: 30%;
  }
}

// burger transition

.burger__svg {
  width: 30px;
  height: 30px;
}

.line {
  fill: none;
  stroke: black;
  stroke-linecap: round;
  stroke-width: 6;
  transition: stroke-dasharray 200ms cubic-bezier(0.4, 0, 0.2, 1),
    stroke-dashoffset 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

.line1 {
  stroke-dasharray: 60 207;
  stroke-width: 6;
}
.line2 {
  stroke-dasharray: 60 60;
  stroke-width: 6;
}
.line3 {
  stroke-dasharray: 60 207;
  stroke-width: 6;
}
.opened .line1 {
  stroke-dasharray: 90 207;
  stroke-dashoffset: -134;
  stroke-width: 6;
}
.opened .line2 {
  stroke-dasharray: 1 60;
  stroke-dashoffset: -30;
  stroke-width: 6;
}
.opened .line3 {
  stroke-dasharray: 90 207;
  stroke-dashoffset: -134;
  stroke-width: 6;
}
</style>
